import React from 'react'
import PropTypes from 'prop-types'
import SydButton from '../../../commonDesign/Button'
import { useDenaliActions } from '../provider/DenaliActionProvider'

function DenaliActionButton ({ code, subject, children, ...buttonProps }) {
  const { open } = useDenaliActions()

  return (
    <SydButton
      onClick={() => open(code, subject)}
      {...buttonProps}
    >
      {children}
    </SydButton>
  )
}

DenaliActionButton.propTypes = {
  code: PropTypes.string.isRequired,
  subject: PropTypes.string,
  children: PropTypes.node,
  // SydButton props that can be forwarded:
  variant: PropTypes.oneOf(['primary', 'secondary', 'outline', 'ghost', 'ai']),
  priority: PropTypes.oneOf(['main', 'warning']),
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  icon: PropTypes.string,
  endIcon: PropTypes.string,
  disabled: PropTypes.bool,
  processing: PropTypes.bool,
  type: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object
}

export default DenaliActionButton
